import { ComposerRowData, FormSchemaItem } from './composer-grid.models';
import { normalizeKey } from './composer-row.mapper';

export function buildPayloads(rowData: ComposerRowData[], formSchema: FormSchemaItem[]): any[] {
  const payloads: any[] = [];

  for (const row of rowData) {
    if (!row.edited) continue;

    const payload: any = {};
    let tabKey = '';

    for (const form of formSchema) {
      const updatedKey = form.key.replace('$', '.');
      let key = '';
      if (updatedKey.includes('.')) {
        const keysArr = updatedKey.split('.');
        tabKey = keysArr[0];
        key = keysArr[keysArr.length - 1];
      } else {
        key = updatedKey;
      }

      if (Object.keys(row).includes('in') && key !== 'in' && !row.editedCell.includes(key)) {
        continue;
      }

      if (['display_only', 'hidden'].includes(form.formtype)) continue;

      if (['tile-autocomplete', 'tile-autoselect', 'autocomplete', 'autoselect'].includes(form.formtype)) {
        if (typeof row[key] === 'object') {
          const val = row[key].rid || row[key].value;
          payload[key] = val.replace('#', '');
        } else {
          const val = row.row.find((e) => key === normalizeKey(e.key));
          payload[key] = val?.rid || val?.value;
        }
      } else if (['select', 'select_boolean'].includes(form.formtype)) {
        const val = form.enum?.find((e) => e.name === row[key]);
        payload[key] = val?.value;
      } else if (form.formtype === 'checkbox') {
        payload[key] = row[key] === true || row[key] === 'true';
      } else {
        payload[key] = row[key];
      }
    }

    payload.rid = row.rid;
    payloads.push(tabKey ? { [tabKey]: payload } : payload);
  }

  return payloads;
}
